import React, { useState, useEffect, useCallback } from 'react';
import './ClaimsNotification.css';

export default function ClaimsNotification({ show, claims, onClose }) {
    const [isVisible, setIsVisible] = useState(false);

    const handleClose = useCallback(() => {
        setIsVisible(false);
        onClose();
    }, [onClose]);

    useEffect(() => {
        if (show) {
            setIsVisible(true);
            // Auto-hide after 5 seconds
            const timer = setTimeout(() => {
                handleClose();
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [show, handleClose]);

    if (!isVisible) return null;

    const getRoleText = () => {
        if (claims?.admin) return 'administrator';
        if (claims?.staff) return 'staff member';
        return 'regular user';
    };

    return (
        <div className="claims-notification">
            <div className="claims-notification-content">
                <span className="claims-notification-icon">🔔</span>
                <span className="claims-notification-message">
                    Your access level has been updated. You are now a {getRoleText()}.
                </span>
                <button className="claims-notification-close" onClick={handleClose}>
                    ✕
                </button>
            </div>
        </div>
    );
} 